import React, { useState, useEffect } from 'react';
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import { saveAs } from "file-saver";
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
    Box,
    Typography,
    TextField,
    Button,
    Snackbar,
    Alert,
    Paper,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from '@mui/material';
import {
    Print,
    ContentCopy,
    Preview,
    PictureAsPdf,
    InsertDriveFile // Generic file icon
} from '@mui/icons-material';
import ReactDOMServer from 'react-dom/server';
//import { jsPDF } from "jspdf";
import * as Icons from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material';
import { PDFDocument } from 'pdf-lib';

const RecipePage = () => {
    const { idHistoria } = useParams();
    const navigate = useNavigate();
    const [recipe, setRecipe] = useState('');
    const [patient, setPatient] = useState(null);
    const [openSnackbar, setSnackbar] = useState(false);
    const [alertMessage, setAlert] = useState("");
    const [severity, setSeverity] = useState("success");
    const location = useLocation();
    const { state } = location;
    const [user, setUser] = useState(null);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/user`, { withCredentials: true });
                setUser(response.data);
            } catch (error) {
                console.error('Error al obtener el usuario:', error);
            }
        };

        fetchUser();
    }, [API_URL]);

    useEffect(() => {
    const loadData = async () => {
        if (state) {
        // Si viene de estado (navegación), usar esos datos
        setRecipe(state.tratamiento || '');
        
        // Si es una nueva historia y no hay paciente en el estado, cargarlo
        if (state.patient) {
            setPatient(state.patient);
        } else if (state.IDPac) {
            const patientRes = await axios.get(`${API_URL}/api/identificacion/${state.IDPac}`);
            setPatient(patientRes.data);
        }
        } else if (idHistoria !== 'new') {
        // Cargar datos existentes si no es nueva
        try {
            const historyRes = await axios.get(`${API_URL}/api/historia/${idHistoria}`);
            const patientRes = await axios.get(`${API_URL}/api/identificacion/${historyRes.data.IDPac}`);
            setPatient(patientRes.data);
            setRecipe(historyRes.data.Tratamiento || '');
        } catch (error) {
            console.error('Error al obtener la receta:', error);
        }
        }
    };

    loadData();
    }, [idHistoria, state, API_URL]);


    const handlePreview = () => {
        const printContent = (
            <div style={{ padding: '20px', whiteSpace: 'pre-wrap' }}>
                <Typography variant="h4" align="center" gutterBottom>
                    Receta Médica
                </Typography>
                <Typography variant="h5" gutterBottom>
                    Centro Médico Medicare
                </Typography>
                <Typography variant="h6" gutterBottom>
                    Paciente: {patient?.nombre || 'No especificado'}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                    Fecha: {new Date().toLocaleDateString()}
                </Typography>
                <Typography variant="h6" gutterBottom>
                    Tratamiento:
                </Typography>
                <Typography variant="body1" paragraph>
                    {recipe || 'No se ha especificado tratamiento'}
                </Typography>
            </div>
        );
    
        const htmlContent = `
            <!DOCTYPE html>
            <html>
                <head>
                    <link 
                        rel="stylesheet" 
                        href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
                    />
                    <style>
                        body { 
                            font-family: Roboto, sans-serif; 
                            margin: 20px; 
                        }
                    </style>
                </head>
                <body>
                    ${ReactDOMServer.renderToString(printContent)}
                </body>
            </html>
        `;
    
        const newWindow = window.open('', '_blank');
        newWindow.document.write(htmlContent);
        newWindow.document.close();
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(recipe);
        setAlert("Texto copiado")
        setSeverity("success")
        setSnackbar(true);
    };

    const handlePrint = () => {
        const printContent = (
          <div style={{ 
            padding: '0.5in', // Ajusta según el espacio en el DOCX
            width: '8.2in',    // Ancho de la imagen en el DOCX
            height: '4.9in',   // Altura de la primera imagen
            fontFamily: 'Arial', 
            margin: 0 
          }}>
            {/* Cabecera */}
            <div style={{ 
              marginBottom: '1in', 
              paddingBottom: '0.2in'
            }}>
              <h1 style={{ fontSize: '20pt', margin: 0 }}> </h1>
              <h2 style={{ fontSize: '16pt', margin: '0.2in 0' }}> </h2>
            </div>
      
            {/* Sección paciente */}
            <div style={{ 
                display: 'flex',
                transform: 'translateY(-0.3in)',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '0.5in',
                fontSize: '12pt'
            }}>
                <span style={{ fontWeight: 'bold' }}>
                ................. {patient?.nombre || 'No especificado'}
                </span>
                <span style={{ marginLeft: '1in' }}>
                 {new Date().toLocaleDateString()}
                </span>
            </div>
      
            {/* Tratamiento */}
            <div style={{ 
              height: '3in', // Altura restante disponible
              overflow: 'hidden',
              transform: 'translateY(-0.6in)',
            }}>
              <h3 style={{ fontSize: '14pt', margin: '0.1in 0' }}> </h3>
              <pre style={{
                whiteSpace: 'pre-wrap',
                fontFamily: 'Arial',
                margin: 0,
                fontSize: '12pt'
              }}>
                {recipe || 'No se ha especificado tratamiento'}
              </pre>
            </div>
          </div>
        );
      
        const htmlContent = `
          <!DOCTYPE html>
          <html>
            <head>
              <style>
                @media print {
                  @page {
                    size: letter;       // Tamaño de papel
                    margin: 0.5in;      // Márgenes del DOCX
                  }
                  body { 
                    margin: 0 !important;
                    -webkit-print-color-adjust: exact; 
                  }
                }
                * { 
                  box-sizing: border-box;
                }
              </style>
            </head>
            <body>
              ${ReactDOMServer.renderToString(printContent)}
            </body>
          </html>
        `;
      
        const printWindow = window.open('', '_blank');
        printWindow.document.write(htmlContent);
        printWindow.document.close();
        printWindow.print();
      };
    
      const handleExportWord = async () => {
        try {
            // Normalizar el nombre del usuario logueado
            const normalizedUserName = user?.username?.toLowerCase().trim();
            console.log("Nombre normalizado del usuario:", normalizedUserName);
            // Lista de variantes del nombre de la Dra. María
            const draMariaNames = [
                "dra maria espinoza",
                "dra maria m espinoza",
                "dra maria"
            ];
    
            // Determinar la plantilla base según el usuario logueado
            let templatePath = "/template.docx"; // Por defecto, usar la plantilla del Dr. Carlos
            if (draMariaNames.includes(normalizedUserName)) {
                templatePath = "/template1.docx";
            }
    
            // Cargar la plantilla base
            const response = await fetch(templatePath);
            const templateArrayBuffer = await response.arrayBuffer();
    
            // Crear un archivo zip a partir de la plantilla
            const zip = new PizZip(templateArrayBuffer);
    
            // Crear una instancia de Docxtemplater
            const doc = new Docxtemplater(zip, {
                paragraphLoop: true,
                linebreaks: true,
            });
    
            // Reemplazar los marcadores de posición con los datos dinámicos
            doc.setData({
                nombre: patient?.nombre || "No especificado",
                fecha: new Date().toLocaleDateString(),
                tratamiento: recipe || "No se ha especificado tratamiento",
            });
    
            try {
                // Renderizar el documento con los datos
                doc.render();
            } catch (error) {
                console.error("Error al renderizar el documento:", error);
                setAlert("Error al generar el documento");
                setSeverity("error");
                setSnackbar(true);
                return;
            }
    
            // Generar el archivo Word como un Blob
            const output = doc.getZip().generate({
                type: "blob",
                mimeType:
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            });
    
            // Descargar el archivo Word
            saveAs(output, `Receta-${patient?.nombre || "paciente"}.docx`);
        } catch (error) {
            console.error("Error al exportar a Word:", error);
            setAlert("Error al exportar a Word");
            setSeverity("error");
            setSnackbar(true);
        }
    };

    const theme = useTheme();

    const handleExportPDF = async () => {
        try {
            if (!user || !user.username) {
                console.error("Usuario no autenticado");
                setAlert("Error: Usuario no autenticado");
                setSeverity("error");
                setSnackbar(true);
                return;
            }
    
            const normalizedUserName = user.username.toLowerCase().trim();
            const draMariaNames = ["dra maria espinoza", "dra maria m espinoza", "dra maria"];
            let templatePath = "/template.pdf";
            if (draMariaNames.includes(normalizedUserName)) {
                templatePath = "/template1.pdf";
            }
    
            const response = await fetch(templatePath);
            const existingPdfBytes = await response.arrayBuffer();
            const pdfDoc = await PDFDocument.load(existingPdfBytes);
            const pages = pdfDoc.getPages();
            const firstPage = pages[0];
    
            // Coordenadas ajustadas para template1.pdf
            // Nombre del Paciente (nombre)
            firstPage.drawText(patient?.nombre || "No especificado", {
                x: 145,  // Ajusta según la posición de "(nombre)" en el PDF
                y: 660,  // Valor basado en el layout del template
                size: 12,
            });
    
            // Fecha (fecha)
            firstPage.drawText(new Date().toLocaleDateString(), {
                x: 470, // Ajusta según la posición de "(fecha)"
                y: 660,
                size: 12,
            });
    
            // R / (tratamiento)
            firstPage.drawText(recipe || "No se ha especificado tratamiento", {
                x: 80,   // Posición debajo de "R /"
                y: 640,
                size: 12,
                maxWidth: 450, // Ajusta el ancho máximo para evitar separación
                lineHeight: 14, // Controla el espaciado entre líneas
            });
    
            const pdfBytes = await pdfDoc.save();
            const blob = new Blob([pdfBytes], { type: "application/pdf" });
            saveAs(blob, `Receta-${patient?.nombre || "paciente"}.pdf`);
        } catch (error) {
            console.error("Error al exportar a PDF:", error);
            setAlert("Error al generar PDF");
            setSeverity("error");
            setSnackbar(true);
        }
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbar(false);
    };

    const handleOpenConfirmModal = () => {
        setOpenConfirmModal(true);
    };

    const handleCloseConfirmModal = () => {
        setOpenConfirmModal(false);
    };


    const handleConfirmSaveHistory = async () => {
        if (!user || !user.username) {
            setAlert("Usuario no autenticado");
            setSeverity("error");
            setSnackbar(true);
            return;
        }

        try {
            // Obtener datos del estado o del formulario
            const historiaData = {
            IDPac: patient.idpac,
            HistoriaT: state?.historia || '',
            Diagnostico: state?.diagnostico || '',
            Tratamiento: recipe,
            Responsable: user.username,
            costo_consulta: state?.costo_consulta || 0
            };

            if (idHistoria === 'new' || state?.isNew) {
            // Crear nueva historia
            await axios.post(`${API_URL}/api/historias`, historiaData, { withCredentials: true });
            } else {
            // Actualizar historia existente
            await axios.put(`${API_URL}/api/historias/${idHistoria}`, historiaData, { withCredentials: true });
            }
            
            // Redirigir a la página de historias
            navigate(`/historias/${patient.idpac}`);
        } catch (error) {
            console.error('Error al guardar la historia:', error);
            setAlert("Error al guardar la historia");
            setSeverity("error");
            setSnackbar(true);
        } finally {
            handleCloseConfirmModal();
        }
        };

    
    return (
        <Box sx={{
            justifyContent: 'center',
            alignItems: 'center',
            flexGrow: 1, 
            p: { xs: 2, sm: 4 }
        }}>
            <Paper
                elevation={3}
                sx={{
                    padding: { xs: 2, sm: 4 }, // Padding responsive
                    width: '100%',
                    maxWidth: '98vw',
                    overflowX: 'auto',
                    borderRadius: 2,
                    margin: 'auto',
                    boxSizing: 'border-box',
                    background: `linear-gradient(135deg, ${theme.palette.background.default} 0%,rgb(238, 245, 178) 100%)`, // Añade el estilo de fondo
                    boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
                }}
            >
                <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
                    <strong>Receta Médica</strong>
                </Typography>
                {patient && <Typography variant="h6" gutterBottom>
                    <strong>Paciente: </strong>{patient.nombre}
                </Typography>}
                <Typography variant="h6" gutterBottom>
                <strong>Fecha: </strong>{new Date().toLocaleDateString()}
                </Typography>
                <TextField
                    fullWidth
                    multiline
                    rows={10}
                    value={recipe}
                    onChange={(e) => setRecipe(e.target.value)}
                    variant="outlined"
                    margin="normal"
                />

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2 }}>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<Preview />}
                    onClick={handlePreview}
                    sx={{ flex: '1 1 auto', minWidth: '120px' }}
                >
                    Vista previa
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<Print />}
                    onClick={handlePrint}
                    sx={{ flex: '1 1 auto', minWidth: '120px' }}
                >
                    Imprimir
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    startIcon={<ContentCopy />}
                    onClick={handleCopy}
                    sx={{ flex: '1 1 auto', minWidth: '120px' }}
                >
                    Copiar
                </Button>
                <Button
                    variant="contained"
                    color="warning"
                    startIcon={<InsertDriveFile />} // Usando el icono genérico
                    onClick={handleExportWord}
                    sx={{ flex: '1 1 auto', minWidth: '120px' }}
                >
                    Word
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    startIcon={<PictureAsPdf />}
                    onClick={handleExportPDF}
                    sx={{ flex: '1 1 auto', minWidth: '120px' }}
                >
                    PDF
                </Button>
                <Button 
                    variant="contained" 
                    color="info" 
                    size="small"
                    startIcon={<Icons.AutoStories />}
                    component={RouterLink}
                    to={`/historias/${patient?.idpac}`}
                    sx={{ flex: '1 1 auto', minWidth: '120px' }}
                >
                   Historial
                </Button>
                <Button
                    variant="contained" 
                    color="success" 
                    size="small"
                    startIcon={<Icons.SaveAs />}
                    onClick={handleOpenConfirmModal}
                    sx={{ flex: '1 1 auto', minWidth: '120px' }}
                >
                    Guardar Historia
                </Button>
            </Box>
            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity={severity} sx={{ width: '100%' }}>
                    {alertMessage}
                </Alert>
            </Snackbar>
            </Paper>
            <Dialog
                open={openConfirmModal}
                onClose={handleCloseConfirmModal}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
            >
                <DialogTitle id="confirm-dialog-title">{"Confirmar Guardado"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="confirm-dialog-description">
                        ¿Estás seguro de que deseas guardar esta historia clínica?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmModal} color="secondary">
                        Cancelar
                    </Button>
                    <Button onClick={handleConfirmSaveHistory} color="primary" autoFocus>
                        Aceptar
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default RecipePage;